const $ = jQuery.noConflict();

'use strict';
const SearchProducts = {
	/*-------------------------------------------------------------------------------
	# Cache dom and strings
-------------------------------------------------------------------------------*/
	$domSearchButton: $('.js-site-header__shop-search-link'),
	$domSearchButtonTitle: $('.js-site-header__shop-search-link span'),
	$domResults: $('.js-display-result div.js-products-display'),
	$domShopSearch: $('.js-search-products'),

	/*-------------------------------------------------------------------------------
        # Initialize
    -------------------------------------------------------------------------------*/
	init: function() {
		$('.js-search-products').val('');
		this.searchProducts();
		this.enterPress();
		this.seeAllProducts();
	},
	searchProducts: function() {
		const search = $('.js-search-products');
		if (search) {
			search.on('keyup', function() {
				const searchValue = $('.js-search-products').val().trim();
				const searchValueLength = searchValue.length;

				if(searchValueLength < 3) {
					$('.js-display-result div').empty();
					$('.js-site-header__shop-search-link').hide();
					return false;
				}
				$.ajax({
					type: 'POST',
					// eslint-disable-next-line no-undef
					url: fwsLocalized.ajaxUrl,
					data: {
						action: 'searchProducts',
						searchValue: searchValue
					},
					success: function(response) {
						if(response.data.product_counter > 0){
							$('.js-products-display').empty();
							const productList = response.data.product_list;
							$.each(productList, function(key, value) {
								if($('.js-search-products').val().trim().length >= 3){
									$('.js-display-result div.js-products-display').append(`
									<a class="site-header__shop-search-dropdown-result" href="${value.permalink}">
									   <div class="site-header__shop-search-dropdown-result-image">
										 <img src="${value.image}" alt="${value.image_alt}">
									   </div>
									   <div class="site-header__shop-search-dropdown-result-texts">
										  <span class="site-header__shop-search-dropdown-result-title">${value.name}</span>
									   </div>
									</a>
								 `);
								}
							});
							if($('.js-search-products').val().trim().length >= 3) {
								SearchProducts.$domSearchButtonTitle.text('Show Results');
								SearchProducts.$domSearchButton.attr('href', window.location.origin + '?s=' + searchValue);
								SearchProducts.$domSearchButton.show();
								SearchProducts.$domSearchButton.css('display', 'block');
							}
						} else {
							$('.js-products-display').empty();
							SearchProducts.$domResults.empty();
							if($('.js-search-products').val().trim().length >= 3) {
								SearchProducts.$domResults.append(`
									<span class="site-header__shop-search-dropdown-no-results">No result found...</span>`);
							}
							SearchProducts.$domSearchButton.hide();
							SearchProducts.$domSearchButton.css('display', 'none');
						}
					}
				});
			});
		}
	},
	enterPress: function() {
		SearchProducts.$domShopSearch.on('keypress', (e)=> {
			const searchValue = SearchProducts.$domShopSearch.val().trim();
			const searchValueLength = searchValue.length;
			if (e.key === 'Enter' || e.keyCode === 13) {
				e.preventDefault();
				if(searchValueLength >= 3) {
					const link = $('.js-menu-btn').attr('href');
					window.location.replace(link);
				}
			}
		});
	},
	seeAllProducts: function(){
		$('.js-menu-btn').on('click', () => {
			$.ajax({
				method: 'POST',
				url: window.fwsLocalized.ajaxUrl,
				data: {
					action: 'searchProducts',
				}
			});
		});
	},
};
export default SearchProducts;
